import Model from './Model'

export default class TrainingProgram extends Model {
  resource() {
    return 'training-programs'
  }
}
